import { Component, OnInit, Input, HostListener, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { interval, Observable, Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { TranslatePipe } from '@pipes/translate.pipe';
import { LocalizationService } from '@services/localization.service';
import { ApiService } from '@services/api.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { environment } from '@environments/environment';
import { IsoCountriesPipe } from '@pipes/isoCountries.pipe';
@Component({
  selector: 'spinner-utils',
  styleUrls: ['./utils.sass'],
  template: ` <ng-container>
    <ng-container *ngIf="spinnerState; else propsBody">
      <ng-container [ngSwitch]="spinnerType">
        <ng-container *ngSwitchCase="'ellipsis'">
          <div class="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <div class="theme-button navbar-right-side-item">
            <div class="lds-spinner">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #propsBody>
      <ng-content></ng-content>
    </ng-template>
  </ng-container>`,
})
export class SpinnerUtils {
  @Input() spinnerState;
  @Input() spinnerType;
}

@Component({
  selector: 'image-loader-utils',
  styleUrls: ['./utils.sass'],
  template: `
    <ng-container [ngSwitch]="this.imageFormat">
      <ng-container *ngSwitchCase="'svg'">
        <svg-icon [src]="this.customUrl || this.svgIcon + '.svg'" [class]="'image-loader ' + this.extraClasses"></svg-icon>
      </ng-container>
      <ng-container *ngSwitchCase="'png'">
        <img [src]="this.customUrl || this.assetPath" [alt]="this.altText || this.customUrl || this.url" [class]="this.extraClasses" class="image-loader-png" />
      </ng-container>
    </ng-container>
  `,
})
export class ImageLoaderUtils implements OnInit, OnChanges {
  public svgIcon: any;
  public assetPath: string;
  @Input() url?: string;
  @Input() customUrl?: string;
  @Input() imageFormat = 'svg';
  @Input() shared?: boolean = true;
  @Input() extraClasses?: string;
  @Input() altText?: string;
  @Input() isFlags?: boolean = false;

  async createIcon() {
    const isoCountry = new IsoCountriesPipe();
    if (this.isFlags) {
      this.assetPath = `${environment.assetsPath}images/shared/flags/${isoCountry.transform(this.url)}`;
      this.svgIcon = `${environment.assetsPath}images/shared/flags/${isoCountry.transform(this.url)}`;
    } else {
      if (environment.assetsOnlyProject) {
        this.assetPath = `${environment.assetsPath}images/${environment.product}/${this.url}`;
        this.svgIcon = `${environment.assetsPath}images/${environment.product}/${this.url}`;
      } else {
        this.assetPath = `${environment.assetsPath}images/${this.shared ? 'shared' : environment.product}/${this.url}`;
        this.svgIcon = `${environment.assetsPath}images/${this.shared ? 'shared' : environment.product}/${this.url}`;
      }
    }
  }

  createImage() {
    if (environment.assetsOnlyProject) {
      this.assetPath = `${environment.assetsPath}images/${environment.product}/${this.url}.png`;
    } else {
      this.assetPath = `${environment.assetsPath}images/${this.shared ? 'shared' : environment.product}/${this.url}.png`;
    }
  }

  ngOnInit() {
    if (this.imageFormat === 'svg') {
      this.createIcon().then();
    } else if (this.imageFormat === 'png') {
      this.createImage();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.url) {
      if (this.imageFormat === 'svg') {
        this.createIcon().then();
      } else if (this.imageFormat === 'png') {
        this.createImage();
      }
    }
  }
}

@Component({
  selector: 'account-menu-selection-utils',
  styleUrls: ['./utils.sass'],
  template: ` <div class="account-menu-selection">
    <select class="form-control select" [ngModel]="this.selectedItem" (ngModelChange)="this.selectionChange.emit($event)">
      <option *ngFor="let item of this.selectionList" attr.value="{{ item.id }}">{{ item.name }}</option>
    </select>
  </div>`,
})
export class AccountMenuSelectionUtils {
  @Input() selectedItem: number;
  @Input() selectionList: { id: number; name: string }[];
  @Output() selectionChange: EventEmitter<any> = new EventEmitter<number>();
}

@Component({
  selector: 'account-lock-button',
  styleUrls: ['./utils.sass'],
  template: ` <div class="lock-button-main-container text sl-round round-5" *ngIf="this._UserHelper.isSignedIn && this.isMobileView === false">
    <div class="lock-info-text">{{ 'b3000_current_slip_core_text_3' | t }}</div>
    <div class="lock-button-box">
      <div id="accountLockButton24" mat-flat-button class="lock-button">
        {{ '24h_Lock' | t }}
      </div>
      <section class="account-lock-section" *ngIf="progressValue > 0">
        <ng-container *ngIf="holdSeconds != 0">
          <mat-progress-bar class="account-lock-progress-bar" mode="determinate" value="{{ this.progressValue }}"></mat-progress-bar>
          <div class="progress-bar-text">{{ holdSeconds }}</div>
        </ng-container>
      </section>
    </div>
  </div>`,
})
export class AccountLockButton {
  @Input() isMobileView;
  @Output() holdTime: EventEmitter<number> = new EventEmitter<number>();
  cancel: Observable<string>;
  state: Subject<string> = new Subject<string>();
  holdSeconds = 0;
  progressValue = 0;
  accountLockIsDisabled = false;
  constructor(private _LocalizationService: LocalizationService, private _ApiService: ApiService, public _UiHelper: UiHelper, public _UserHelper: UserHelper) {
    this.cancel = this.state.pipe(
      filter(v => v === 'cancel'),
      tap(v => {
        this.holdTime.emit(0);
        this.holdSeconds = 0;
        this.progressValue = 0;
      })
    );
  }

  @HostListener('mouseup', ['$event'])
  @HostListener('mouseleave', ['$event'])
  onExit() {
    this.state.next('cancel');
  }

  @HostListener('mousedown', ['$event'])
  onHold(e) {
    const target = e.target || e.srcElement || e.currentTarget;
    const idAttr = target.attributes.id;
    if (idAttr == undefined) {
      return '';
    }

    const value = idAttr.nodeValue;
    if (value != 'accountLockButton24') {
      return '';
    }
    this.state.next('start');

    const n = 100;
    interval(n)
      .pipe(
        takeUntil(this.cancel),
        tap(v => {
          const result = v * n;
          this.holdSeconds = result / 1000;
          this.progressValue = (this.holdSeconds / 3) * 100;
          if (result == 3000) {
            this.state.next('cancel');

            const translator = new TranslatePipe(this._LocalizationService);
            this._ApiService.accountLock24().then(result => {
              if (result.code == '') {
                return 'error|System Error';
              } else {
                if (result.code == 'error') {
                  this._UiHelper.errorSnackBar(result.message, '');
                } else if (result.code == 'errorcode') {
                  const t_message = translator.transform(result.message, null);
                  this._UiHelper.errorSnackBar(t_message, '');
                } else if (result.code == 'success') {
                  this._UiHelper.successSnackBar(result.message, '');
                  this.holdSeconds = 0;
                  this.progressValue = 0;
                  this.accountLockIsDisabled = true;
                }
              }
            });
          }

          this.holdTime.emit(result);
        })
      )
      .subscribe();
  }
}
